import React, { FC, useEffect } from "react";
import { Table, Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useWarehouseDetailModel } from "./warehouseDetailModel";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { IpositionDetail } from "../../warehouseService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        positionSource,
        selectedPositionRows,
        positionPgCfg,
        positionLoadData,
        setIpositionDrawer,
        setSelectedPositionRows, } = useWarehouseDetailModel();

    useEffect(() => {
        // positionLoadData()
    }, [])

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '仓库名称',
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            title: '货位编码',
            width: 160,
            dataIndex: 'code',
        }, {
            title: '创建人',
            width: 160,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 160,
            dataIndex: 'createTime',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },
    ];

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DATA_S_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { setIpositionDrawer("add") }}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_S_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { setIpositionDrawer("edit") }}
            >编辑</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { }}
            >导入</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_S_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { }}
            >导出</Button>
        </YhAuth> */}
    </>;

    const onRow = (record: IpositionDetail) => {
        let findArr = selectedPositionRows.find(item => item.id === record.id);
        if (findArr) {
            let filterArr = selectedPositionRows.filter(item => item.id !== record.id);
            setSelectedPositionRows(filterArr);
        } else {
            setSelectedPositionRows(origin => [...origin, record]);
        }
    };

    return (
        <YhBox title="货位详情" style={{ marginBottom: "75px" }} rightChildren={action} >
            <Table
                rowKey={record => record.id}
                rowSelection={{
                    selectedRowKeys: selectedPositionRows.map(item => item.id), //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IpositionDetail[]) => {
                        setSelectedPositionRows(selectedRows);
                    }
                }}
                columns={columns}
                dataSource={positionSource}
                pagination={{
                    ...positionPgCfg,
                    position: ["bottomCenter"],
                    showTotal: () => `共${positionPgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        positionLoadData({ pageNum, pageSize })
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record)
                })}
                scroll={{ x: 'max-content' }}
            />
        </ YhBox >
    )
}